import { motion, useReducedMotion } from "motion/react";
import { cinematicEase } from "../ui/reveal-text";
import { CURTAIN_ID } from "@/lib/scroll-to-section";

/**
 * The "lens" over the whole site: a vignette under the content, a fine film
 * grain above it, and letterbox bars that open like a title sequence on
 * first paint. None of it takes pointer events.
 */
export default function CinematicOverlay() {
  const reduceMotion = useReducedMotion();

  return (
    <>
      <svg className="absolute h-0 w-0" aria-hidden="true">
        <filter id="text-outline" colorInterpolationFilters="sRGB">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1"
            result="grown"
          />
          <feComposite
            in="grown"
            in2="SourceAlpha"
            operator="out"
            result="ring"
          />
          <feFlood floodColor="#ffffff" floodOpacity="0.34" />
          <feComposite in2="ring" operator="in" />
        </filter>
      </svg>
      <div className="vignette z-[1]" aria-hidden="true" />
      <div
        className="film-grain-frame pointer-events-none fixed inset-0 z-[70] overflow-hidden"
        aria-hidden="true"
      >
        <div className="film-grain" />
      </div>
      <div
        id={CURTAIN_ID}
        className="pointer-events-none fixed inset-0 z-[75] bg-[#000508] opacity-0"
        aria-hidden="true"
      />
      {!reduceMotion && (
        <div
          className="pointer-events-none fixed inset-0 z-[80]"
          aria-hidden="true"
        >
          <motion.div
            className="absolute inset-x-0 top-0 h-[14vh] origin-top bg-[#000508]"
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0 }}
            transition={{ duration: 1.3, delay: 0.25, ease: cinematicEase }}
          />
          <motion.div
            className="absolute inset-x-0 bottom-0 h-[14vh] origin-bottom bg-[#000508]"
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0 }}
            transition={{ duration: 1.3, delay: 0.25, ease: cinematicEase }}
          />
          <motion.div
            className="absolute inset-0 bg-[#000508]"
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          />
        </div>
      )}
    </>
  );
}
